import React from "react";
import { Link } from "react-router-dom";


export default function CustomerDashboard() {
  const cards = [
    {
      title: "Book",
      link: "/customer/book",
      color: "linear-gradient(135deg, #d1ee13ff, #d1ee13ff)",
      description: "Manage your personal library and track your readings.",
      cta: "Go to Library",
    },
    {
      title: "Repository",
      link: "/customer/repository",
      color: "linear-gradient(135deg, #d1ee13ff, #d1ee13ff)",
      description: "Access and organize your project repositories.",
      cta: "View Repositories",
    },
    
    {
      title: "Blog",
      link: "/customer/blogs",
      color: "linear-gradient(135deg, #d1ee13ff,#d1ee13ff)",
      description: "Read and publish articles on your favorite topics.",
      cta: "Read Blogs",
    },
    {
      title: "Shop",
      link: "/customer/shop",
      color: "linear-gradient(135deg, #d1ee13ff,#d1ee13ff)",
      description: "Shop for exclusive items and deals curated for you.",
      cta: "Start Shopping",
    },
  ];

  return (
    <div
      style={{
        padding: "40px 20px",
        background: "#f4f6f9",
        minHeight: "100vh",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      <h1
        className="text-center"
        style={{
          color: "#222",
          fontWeight: "600",
          marginBottom: "30px",
          fontSize: "2rem",
        }}
      >
        👋 Welcome Back!
      </h1>

      <div
        style={{
          display: "flex",
          gap: "20px",
          maxWidth: "1200px",
          margin: "0 auto",
          overflowX: "auto",
          paddingBottom: "10px",
        }}
      >
        {cards.map((card) => (
          <div
            key={card.title}
            style={{
              flex: "0 0 calc(25% - 15px)",
              minWidth: "250px",
              background: "#fff",
              borderRadius: "16px",
              boxShadow: "0 8px 18px rgba(0,0,0,0.07)",
              overflow: "hidden",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 12px 24px rgba(0,0,0,0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 8px 18px rgba(0,0,0,0.07)";
            }}
          >
            <div
              style={{
                background: card.color,
                padding: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ color: "#fff" }}>{card.icon}</div>
            </div>
            <div style={{ padding: "15px", textAlign: "center" }}>
              <h3
                style={{
                  margin: "8px 0 4px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                {card.title}
              </h3>
              <p
                style={{
                  fontSize: "0.85rem",
                  color: "#666",
                  margin: "0 0 8px",
                }}
              >
                {card.description}
              </p>
              <div
                style={{
                  fontSize: "0.8rem",
                  color: "#555",
                  marginBottom: "8px",
                }}
              >
                📊 <strong>{card.stats}</strong>
              </div>
              <Link
                to={card.link}
                style={{
                  display: "inline-block",
                  background: "#007bff",
                  color: "#fff",
                  padding: "6px 14px",
                  borderRadius: "20px",
                  textDecoration: "none",
                  fontWeight: "500",
                  fontSize: "0.85rem",
                  transition: "background 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#0056b3")}
                onMouseLeave={(e) => (e.target.style.background = "#007bff")}
              >
                {card.cta}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}